import { useCallback } from 'react'
import { useStore } from 'react-redux'
import { messageBoxHideAction } from '../../../../reducers/message-box/action'

const useHideTopMessageBox = dispatch => {
  const store = useStore()

  return useCallback(() => {
    const messageBoxContents = store.getState()?.messageBox?.contents || []
    const topMessageBoxIndex = messageBoxContents.length - 1
    if (topMessageBoxIndex >= 0) {
      dispatch(messageBoxHideAction(`message-box-${topMessageBoxIndex}`))
    }
  }, [store, dispatch])
}

export default useHideTopMessageBox
